import dataService from "../../api";

import { startLoading, stopLoading, serverErrorMessage,showNotification, showAlert, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        salaryDoctors: [],
        doctors: [],
        
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.data.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.salaryDoctors = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        setDoctors: (state, data) => (state.doctors = data),
    },
    actions: {
        async getAll(_, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");
                    const response = await dataService.salaryDoctorsReport.getAll(paramsString);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data);

                // commit('SET_ITEMS', response.data.salaryDoctors);
                // commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
      async createSettlement(_,paylod) {
            startLoading()
            try {
               
                    const response = await dataService.salaryDoctorsReport.createSettlement(paylod);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

            showNotification(response.data.message);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
           async getDoctors({ commit }) {
            startLoading()
            try {
               
                    const response = await dataService.salaryDoctorsReport.getDoctors();

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('setDoctors', response.data.doctors);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
     
       
    },
};
